export default {
	name: 'finacial-management',
	path: '/finacial-management',
	redirect: '/finacial-management/consumption',
	meta: {
		title: '财务管理',
		icon: 'icon-comsuption'
	},
	// component: () =>
	// 	import(/*webpackChunkName: "consumption"*/ '@/views/finacial-management/consumption')
	children: [
		{
			name: 'micro-class-award',
			path: 'micro-class-award',
			fullPath: '/finacial-management/micro-class-award/award-details',
			redirect: '/finacial-management/micro-class-award/award-details',
			meta: {
				title: '微课奖励'
			},
			component: () =>
				import(/* webpackChunkName: "result-management" */ '@/views/finacial-management/micro-class-award'),
			children: [
				{
					name: 'award-details',
					path: 'award-details',
					fullPath: '/finacial-management/micro-class-award/award-details',
					meta: {
						title: '奖励明细'
					},
					component: () =>
						import(/*webpackChunkName: "consumption"*/ '@/views/finacial-management/micro-class-award/award-details')
				},
				{
					name: 'award-settings',
					path: 'award-settings',
					fullPath: '/finacial-management/micro-class-award/award-settings',
					meta: {
						title: '奖励设置'
					},
					component: () =>
						import(/*webpackChunkName: "consumption"*/ '@/views/finacial-management/micro-class-award/award-settings')
				},
				{
					name: 'award-statistics',
					path: 'award-statistics',
					fullPath: '/finacial-management/micro-class-award/award-statistics',
					meta: {
						title: '统计'
					},
					component: () =>
						import(/*webpackChunkName: "consumption"*/ '@/views/finacial-management/micro-class-award/award-statistics')
				}
			]
		},
		{
			name: 'consumption-children',
			path: 'consumption',
			redirect: '/finacial-management/consumption/statistics',
			meta: {
				title: '消费系统'
			},
			component: () =>
				import(/*webpackChunkName: "consumption"*/ '@/views/finacial-management/consumption'),
			children: [
				{
					name: 'statistics-children',
					path: 'statistics',
					fullPath: '/finacial-management/consumption/statistics',
					meta: {
						title: '统计报表'
					},
					component: () =>
						import(/*webpackChunkName: "consumption"*/ '@/views/finacial-management/consumption/statistics')
				},
				{
					name: 'account-children',
					path: 'account',
					fullPath: '/finacial-management/consumption/account',
					meta: {
						title: 'consumption_account'
					},
					component: () =>
						import(/*webpackChunkName: "consumption"*/ '@/views/finacial-management/consumption/account')
				},
				// 商户管理
				{
					name: 'merchant-children',
					path: 'merchant',
					fullPath: '/finacial-management/consumption/merchant',
					meta: {
						title: 'consumption_merchant'
					},
					component: () =>
						import(/*webpackChunkName: "consumption"*/ '@/views/finacial-management/consumption/merchant')
				}
			]
		},
		{
			name: 'distribution',
			path: 'distribution',
			fullPath: '/finacial-management/distribution',
			redirect: '/finacial-management/distribution/commission',
			meta: {
				title: '代理商奖励',
				keepAlive: true
			},
			component: () =>
				import(/*webpackChunkName: "distribution"*/ '@/views/finacial-management/distribution'),
			children: [
				{
					// 代理商登录
					name: 'distribution-commission-agent',
					path: 'agent',
					fullPath: '/finacial-management/distribution/agent',
					meta: {
						title: '收益奖励'
					},
					component: () =>
						import(/*webpackChunkName: "distribution"*/ '@/views/finacial-management/distribution/commission/agent')
				},
				{
					// 运营登录
					name: 'distribution-commission-business',
					path: 'business',
					fullPath: '/finacial-management/distribution/business',
					meta: {
						title: '收益奖励'
					},
					component: () =>
						import(/*webpackChunkName: "distribution"*/ '@/views/finacial-management/distribution/commission/business')
				},
				{
					name: 'detail',
					path: 'detail',
					fullPath: '/finacial-management/distribution/detail',
					meta: {
						title: ''
					},
					component: () =>
						import(/*webpackChunkName: "distribution"*/ '@/views/finacial-management/distribution/detail')
				},
				{
					name: 'distribution-setting',
					path: 'setting',
					fullPath: '/finacial-management/distribution/setting',
					meta: {
						title: '提现账号设置'
					},
					component: () =>
						import(/*webpackChunkName: "distribution"*/ '@/views/finacial-management/distribution/setting')
				},
				{
					name: 'distribution-withdraw',
					path: 'withdraw',
					fullPath: '/finacial-management/distribution/withdraw',
					meta: {
						title: '提现'
					},
					component: () =>
						import(/*webpackChunkName: "distribution"*/ '@/views/finacial-management/distribution/withdraw')
				}
			]
		}
	]
};
